import pythonApiClient from "./pythonBaseApi";

const homologacionComensalesLogiflexApi = {
  /**
   * Vista previa o aplicar homologación comensales ↔ Logiflex.
   * @param {number} proyectoId
   * @param {{ aplicar?: boolean, id_cliente?: number|null }} options
   */
  ejecutar: (proyectoId, options = {}) => {
    const { aplicar = false, id_cliente = null } = options;
    return pythonApiClient.post(
      "/procesos/alimentacion/homologacion-comensales-logiflex/ejecutar",
      { aplicar, id_cliente: id_cliente || null },
      {
        headers: { "X-Proyecto-ID": proyectoId },
        timeout: 180000,
      }
    );
  },

  /**
   * Actualiza nombre SGC con el de Logiflex (CONFLICTO_NOMBRE).
   */
  resolverConflictoNombre: (proyectoId, payload) => {
    return pythonApiClient.post(
      "/procesos/alimentacion/homologacion-comensales-logiflex/resolver-conflicto-nombre",
      payload,
      {
        headers: { "X-Proyecto-ID": proyectoId },
      }
    );
  },

  /**
   * Crea un comensal desde una fila CREAR.
   */
  crearComensal: (proyectoId, payload) => {
    return pythonApiClient.post(
      "/procesos/alimentacion/homologacion-comensales-logiflex/crear-comensal",
      payload,
      {
        headers: { "X-Proyecto-ID": proyectoId },
      }
    );
  },
};

export default homologacionComensalesLogiflexApi;
